import ListIcon from '@mui/icons-material/List'
import { Paper } from '@mui/material'
import { CustomTable, FormHeader } from 'components'
import { ITableHeadCellDTO } from 'data/dtos/components/i-table-head-cell-dto'
import { IProfileOptionDTO } from 'data/dtos/security/i-profile-option-dto'
import React, { useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadCellDTO[] = [
  {
    id: 'name',
    label: 'Perfil',
    width: 6,
  },
  {
    id: 'label',
    label: 'Opção de Menu',
    width: 5,
  },
]

const ProfileOptionList: React.FC = () => {
  const [loading, setLoading] = useState(0)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(100)
  const [orderByDirection, setOrderByDirection] = useState(true)
  const [rowsCount, setRowsCount] = useState(0)
  const [profileOptionsList, setProfileOptionsList] = useState<IProfileOptionDTO[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadProfileOptions = async () => {
    setLoading(1)

    await api
      .post('/profile-options/list', { search, page, rowsPerPage, columnOrder })
      .then(async (listResponse) => {
        const { data } = listResponse.data
        setProfileOptionsList(data)

        await api
          .post('/profile-options/count', { search })
          .then((countResponse) => {
            const { count } = countResponse.data.data
            setRowsCount(count)
          })
          .then(() => setLoading(0))
          .catch((error) => {
            console.log(error)
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleDelete = async () => {
    await api
      .delete(`/profile-options/${recordToDelete}`)
      .then(async () => {
        await loadProfileOptions()
      })
      .catch((error) => {
        console.log(error.response?.data)
      })
  }

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadProfileOptions()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadProfileOptions()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Paper
      elevation={3}
      className={classes.paper}
    >
      <FormHeader
        title='Opções do Perfil'
        icon={ListIcon}
        newRoute='/profile-options/new'
        helpText='Nesta opção serão relacionadas as opções de menu possíveis de serem acessadas por cada perfil.'
      />

      <CustomTable
        headCells={headCells}
        rows={profileOptionsList}
        totalRows={rowsCount}
        handleSearch={setSearch}
        isLoading={loading}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        page={page}
        editRoute='/profile-options/edit'
        handleDelete={handleDelete}
        handleRecordToDelete={setRecordToDelete}
        columnOrder={columnOrder}
        setColumnOrder={setColumnOrder}
        orderByDirection={orderByDirection}
        setOrderByDirection={setOrderByDirection}
      />
    </Paper>
  )
}

export default ProfileOptionList
